import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { Autocomplete, TextField, Typography } from '@mui/material';
import useBillingTemplateModalContentStyles from '../styles';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
export const UtilitiesAutocomplete = observer(_ref => {
  let utility = _ref.utility,
    isCustomProviderMode = _ref.isCustomProviderMode,
    currentProviderDataExt = _ref.currentProviderDataExt;
  const classes = useBillingTemplateModalContentStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(currentProviderDataExt || null),
    _useState2 = _slicedToArray(_useState, 2),
    currentProviderData = _useState2[0],
    setCurrentProviderData = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    utilityInputValue = _useState4[0],
    setUtilityInputValue = _useState4[1];
  const getUnselectedUtilitiesOptions = (event, valueExt) => {
    var _store$homeDashboardS, _utility$provider;
    if (currentProviderData === null) {
      return [];
    }
    const providerEnabledUtilitiesIds = (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.details.utilityTemplatesList.filter(template => template.provider.utilityProviderId === (currentProviderData === null || currentProviderData === void 0 ? void 0 : currentProviderData.id)).map(i => i.utilityId);
    const value = valueExt || utilityInputValue;
    if (value && value.length > 0 && (isCustomProviderMode || utility !== null && utility !== void 0 && (_utility$provider = utility.provider) !== null && _utility$provider !== void 0 && _utility$provider.isCustom)) {
      return [{
        id: 'customUtilityId' + '_' + utilityInputValue,
        key: 'customUtilityKey' + '_' + utilityInputValue,
        label: utilityInputValue + ' (Create Custom Utility)',
        inputName: utilityInputValue,
        isCustom: true
      }, ...((currentProviderData === null || currentProviderData === void 0 ? void 0 : currentProviderData.utilities.filter(ut => !providerEnabledUtilitiesIds.includes(ut.id)).map(utType => {
        if (isCustomProviderMode) {
          if (utility.id !== 'NEW_UTILITY_TEMPLATE') {
            return _objectSpread(_objectSpread({}, utType), {}, {
              key: utType.id,
              label: utType.name,
              utilityTypeName: utType.name
            });
          }
          return utType;
        }
        return _objectSpread(_objectSpread({}, utType), {}, {
          key: utType.id,
          label: utType.name,
          utilityTypeName: utType.name
        });
      }).filter(utType => utType.id !== utility.utilityId)) || [])];
    } else {
      return (currentProviderData === null || currentProviderData === void 0 ? void 0 : currentProviderData.utilities.filter(ut => !providerEnabledUtilitiesIds.includes(ut.id)).map(utType => {
        if (isCustomProviderMode) {
          if (utility.id !== 'NEW_UTILITY_TEMPLATE') {
            return _objectSpread(_objectSpread({}, utType), {}, {
              key: utType.id,
              label: utType.name,
              utilityTypeName: utType.name
            });
          }
          return utType;
        }
        return _objectSpread(_objectSpread({}, utType), {}, {
          key: utType.id,
          label: utType.name,
          utilityTypeName: utType.name
        });
      }).filter(utType => utType.id !== utility.utilityId)) || [];
    }
  };
  const fetchUtilityInfos = async currentProviderExt => {
    var _store$homeDashboardS2, _currentProviderExt$u, _currentProviderData$;
    await ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.fetchUtilitiesInfo((currentProviderExt === null || currentProviderExt === void 0 || (_currentProviderExt$u = currentProviderExt.utilities) === null || _currentProviderExt$u === void 0 ? void 0 : _currentProviderExt$u.map(ut => ut.id)) || (currentProviderData === null || currentProviderData === void 0 || (_currentProviderData$ = currentProviderData.utilities) === null || _currentProviderData$ === void 0 ? void 0 : _currentProviderData$.map(ut => ut.id))));
  };
  const fetchProvider = async () => {
    if (isCustomProviderMode && utility.id === 'NEW_UTILITY_TEMPLATE') {
      const resp = await store.utilityProviders.getAllUtilityTypesAsync.run({}, [utility.id]);
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _store$homeDashboardS3;
        utility.provider.setGenericUtilities(resp.response.map(utType => {
          return _objectSpread(_objectSpread({}, utType), {}, {
            id: utType.utilityTypeId,
            label: utType.utilityTypeName
          });
        }));
        setCurrentProviderData({
          utilities: resp.response.map(utType => {
            return _objectSpread(_objectSpread({}, utType), {}, {
              id: utType.utilityTypeId,
              label: utType.utilityTypeName
            });
          })
        });
        (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || _store$homeDashboardS3.setUtilitiesInfoForCustomProvider(resp.response.map(utType => {
          return _objectSpread(_objectSpread({}, utType), {}, {
            utilityId: utType.utilityTypeId,
            providerName: 'CUSTOM_PROVIDER'
          });
        }));
      }
      return;
    }
    if (currentProviderData === null) {
      await store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [utility.provider.utilityProviderId]
      }).then(async resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          setCurrentProviderData(singleElementOfArray(resp.response));
          await fetchUtilityInfos(singleElementOfArray(resp.response));
        }
      });
    } else {
      await fetchUtilityInfos();
    }
  };
  const updateBillingTemplateInitials = () => {
    var _store$homeDashboardS4;
    utility.updateProviderModalInitials((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.getUtilityInfoById(utility === null || utility === void 0 ? void 0 : utility.utilityId));
  };
  useEffect(() => {
    fetchProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCustomProviderMode]);
  useEffect(() => {
    setCurrentProviderData(currentProviderDataExt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProviderDataExt === null || currentProviderDataExt === void 0 ? void 0 : currentProviderDataExt.id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.please_setup_utilities'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete
  // multiple={false}
  , {
    variant: "plain",
    popupIcon: null,
    clearIcon: true,
    id: "utilities-list",
    disabled: utility.id !== 'NEW_UTILITY_TEMPLATE' || store.utilityProviders.getAllUtilityTypesAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress,
    value: utility.utilityName,
    options: getUnselectedUtilitiesOptions(),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: store.utilityProviders.getAllUtilityTypesAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress ? t('general.loading') : t('add_new_property_flow.utilities')
    })),
    renderOption: (props, option) => {
      return /*#__PURE__*/React.createElement("li", _extends({}, props, {
        key: props.id + '_' + option.id
      }), option.label);
    },
    inputValue: utilityInputValue,
    onInputChange: (event, newInputValue) => {
      event === null || event === void 0 || event.preventDefault();
      event === null || event === void 0 || event.stopPropagation();
      setUtilityInputValue(newInputValue);
      // getUnselectedUtilitiesOptions(event, newInputValue);
    },
    onChange: (event, newValue) => {
      if (newValue.isCustom) {
        utility.configureUtilityType(newValue);
      } else {
        utility.configureUtilityType(newValue);
      }
      updateBillingTemplateInitials();
    }
  })));
});